import React from 'react'
import { Customer } from '../models/shared/Customer'
import { IntegrationType } from '../models/shared/Organization'

interface Props {
    customer: Customer | null | undefined
    accountingType: IntegrationType | undefined
}

export default function AccountingSystemBadge({ customer, accountingType }: Props) {
    if (!customer?.accountingSystemId || !accountingType) return null

    const label = accountingType

    return (
        <span className='badge bg-secondary text-decoration-none' >
            {label} #{customer.accountingSystemId}
        </span>
    )
}
